<template>
	<b-modal ref="mdlConfigurazioneMagazzinoUmArticoli" :title="title" centered no-close-on-backdrop no-close-on-esc
		hide-header-close size="lg">
		<b-row>
			<b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
				<label class="sa-label-data">Codice Azienda</label>
				<span v-if="isReadOnly">{{ localData.codiceAzienda }}</span>
				<b-form-select v-else v-model="localData.codiceAzienda">
					<template #first>
						<b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
					</template>
					<b-form-select-option v-for="item in strutturaOptions" :key="item.id" :value="item.codiceStruttura">
						<span>{{ `${item.denominazione} (${item.codiceStruttura}) ` }}</span>
					</b-form-select-option>
				</b-form-select>
			</b-col>
			<b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
				<label class="sa-label-data">Codice</label>
				<span v-if="isReadOnly">{{ localData.codiceMoltiplicatore }}</span>
				<b-form-input v-else v-model="localData.codiceMoltiplicatore" type="text"></b-form-input>
			</b-col>
			<b-col cols="12" xs="12" sm="12" md="5" lg="5" xl="5">
				<label class="sa-label-data">Descrizione</label>
				<span v-if="isReadOnly"> {{ localData.descrizioneMultiplo }}</span>
				<b-form-input v-else v-model="localData.descrizioneMultiplo"></b-form-input>
			</b-col>
			<b-col cols="12" xs="12" sm="12" md="1" lg="1" xl="1">
				<label class="sa-label-data">Multiplo</label>
				<span v-if="isReadOnly">{{ localData.multiplo }}</span>
				<b-form-input v-else v-model="localData.multiplo"></b-form-input>
			</b-col>

			<b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
				<label class="sa-label-data">U.M Base</label>
				<span v-if="isReadOnly">{{ getDescrizioneUm(localData.umBaseId) }}</span>
				<b-form-select v-else v-model="localData.umBaseId" @change="onChangeUmBaseId">
					<template #first>
						<b-form-select-option :value="null"> Nessuna </b-form-select-option>
					</template>
					<b-form-select-option v-for="item in getMisureBaseUM" :key="item.id" :value="item.id">
						<span>{{ `${item.descrizioneMultiplo}` }}</span>
					</b-form-select-option>
				</b-form-select>
			</b-col>
			<b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
				<label class="sa-label-data">Codice U.M</label>
				<span v-if="isReadOnly">{{ baseUmSelezionato.codiceMoltiplicatore }}</span>
				<b-form-input v-else :disabled="true" v-model="baseUmSelezionato.codiceMoltiplicatore"
					type="text"></b-form-input>
			</b-col>
			<b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
				<label class="sa-label-data">Multiplo</label>
				<span v-if="isReadOnly">{{ baseUmSelezionato.multiplo }}</span>
				<b-form-input v-else :disabled="true" v-model="baseUmSelezionato.multiplo"></b-form-input>
			</b-col>
		</b-row>

		<template #modal-footer>
			<b-button v-if="!isReadOnly" size="md" variant="outline-danger" @click="onCloseModal">Annulla</b-button>
			<b-button v-if="!isReadOnly" size="md" variant="outline-success"
				@click="onClickSalvaUmArticolo">Salva</b-button>
			<b-button v-if="isReadOnly" size="md" variant="outline-secondary" @click="onCloseModal">Chiudi</b-button>
		</template>
		<modal-error ref="cmpModalError"></modal-error>
	</b-modal>
</template>

<script>
import ModalError from "../../../template/components/modal/components/ModalError.vue";
import toast from "../../../template/layout/utility/sa-toast";
import StruttureMixin from "../../strutture/mixins/StruttureMixin";
import UtilityMixin from "../../utility/UtilityMixin";
import MagazzinoMixins from "../mixins/MagazzinoMixins";

export default {
	mixins: [UtilityMixin, StruttureMixin, MagazzinoMixins],
	components: { ModalError },
	data() {
		return {
			title: null,
			isReadOnly: false,
			pathResource: "/magazzinoarticolium",
			localData: {
				id: null,
				codiceAzienda: null,
				descrizioneMultiplo: null,
				multiplo: 0,
				codiceMoltiplicatore: null,
				umBaseId: null,
			},
			baseUmSelezionato: { codiceMoltiplicatore: null, multiplo: null },
		};
	},
	props: {
		jsonData: {
			type: Object,
			default: () => {
				return null;
			},
		},
	},
	computed: {
		getMisureBaseUM() {
			let returnValue = [];
			if (this.magazzinoArticoliUnitaMisuraOptions[0]) {
				this.magazzinoArticoliUnitaMisuraOptions.forEach((element) => {
					if (!element.umBaseId) {
						returnValue.push(element);
					}
				});
			}

			return returnValue;
		},
		isValidateComplete() {
			return this.validazione().esito;
		}


	},

	mounted() {
		this.struttureLoadData();
		this.mangazzinoArticoliUnitaMisuraLoadData();
	},
	methods: {

		show(jsonData, isReadOnly) {
			let me = this;
			me.localData = jsonData;
			me.isReadOnly = isReadOnly;
			if (isReadOnly) {
				me.title = "Visualizzazione Unità di Misura";
			} else {
				me.title = !jsonData.id ? "Nuova Unità di Misura" : "Aggiorna Unità di Misura";
			}

			this.onChangeUmBaseId(jsonData.umBaseId);
			me.$refs.mdlConfigurazioneMagazzinoUmArticoli.show();
		},
		validazione() {
			let msg = "";
			let esito = true;

			if (this.localData.codiceAzienda == null || this.localData.codiceAzienda.trim() == "") {
				msg += "Codice Azienda non valido ! #";
				esito = false;
			}
			if (this.localData.descrizioneMultiplo == null || this.localData.descrizioneMultiplo.trim() == "") {
				msg += "Descrizione Multiplo non valido ! #";
				esito = false;
			}
			if (this.localData.multiplo == null || this.localData.multiplo == 0) {
				msg += "Multiplo non valido ! #";
				esito = false;
			}
			return { msg: msg, esito: esito }
		},



		onClickSalvaUmArticolo() {
			let me = this;

			let validation = this.validazione();

			if (validation.esito) {
				UtilityMixin.methods.saveResource(me.pathResource, me.localData, me.salvaUmArticoloSuccess, me.salvaUmArticoloError);
			} else {
				toast.validation(validation);
			}
		},
		getDescrizioneUm(id) {
			return this.magazzinoArticoliUnitaMisuraOptions.filter((e) => e.id == id)[0]?.descrizioneMultiplo;
		},

		onChangeUmBaseId(valore) {
			this.baseUmSelezionato = { codiceMoltiplicatore: null, multiplo: null };
			if (valore) {
				let misuraBase = this.magazzinoArticoliUnitaMisuraOptions.filter((e) => e.codiceAzienda == this.localData.codiceAzienda && e.id == valore);
				if (misuraBase[0]) {
					this.baseUmSelezionato = misuraBase[0];
				}
			}
		},
		salvaUmArticoloSuccess(response) {
			let me = this;
			me.$emit("saveUmArticolo", response);
			me.$refs.mdlConfigurazioneMagazzinoUmArticoli.hide();
			me.$bvToast.toast("Salvataggio avvenuto con successo", {
				title: "Successo",
				variant: "success",
				solid: true,
			});
		},
		salvaUmArticoloError(error) {
			let me = this;
			me.$emit("saveUmArticolo", error);
			me.$refs.cmpModalError.show(error.response.data.messaggio);
		},

		onDeleteUmArticolo(item) {
			let me = this;
			me.$bvModal
				.msgBoxConfirm("Sei sicuro di eliminare questa configurazione?", {
					title: "Eliminazione U.M",
					buttonSize: "sm",
					okTitle: "SI",
					cancelTitle: "NO",
					okVariant: "danger",
					cancelVariant: "secondary",
					hideHeaderClose: true,
					footerClass: "p-2",
					centered: true,
				})
				.then((value) => {
					if (value) {
						me.deleteUmArticolo(item.id);
					}
				})
				.catch((err) => {
					console.log(err);
				});
		},

		deleteUmArticolo(id) {
			let me = this;
			UtilityMixin.methods.deleteResource(me.pathResource + "/" + id, null, me.deleteUmArticoloSuccess, me.deleteUmArticoloError);
		},
		deleteUmArticoloSuccess(response) {
			let me = this;
			me.$emit("umArticoloDelete", response);
			me.$bvToast.toast("Eliminazione avvenuta con successo", {
				title: "Successo",
				variant: "success",
				solid: true,
			});
		},
		deleteUmArticoloError(response) {
			let me = this;
			me.$emit("umArticoloDelete", response);
			me.$bvToast.toast("Errore durante l'eliminazione", {
				title: "Errore",
				variant: "danger",
				solid: true,
			});
		},

		onCloseModal() {
			let me = this;
			me.localData = {
				id: null,
				codiceAzienda: null,
				descrizioneMultiplo: null,
				multiplo: 0,
				codiceMoltiplicatore: null,
				umBaseId: null,
			};
			me.$emit("onCloseModal");
			me.$refs.mdlConfigurazioneMagazzinoUmArticoli.hide();
		},
	},
};
</script>
